/* eslint-disable */
import { $handleError } from "@/utils";
import schedulerService from "../service/scheduler.service";
import moment from "moment";
import router from "@/router";
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';

export const SCHEDULER = {
    namespaced: true,
    state: {
        renderScheduler: false,
        schedulerEvents: [],
        total: 0,
        loading: false,
        updateLoading: false,
        options: {
            sortDesc: false,
            itemsPerPage: 1000,
            page: 1,
            search: '',
        },
        uploadedData: null,
        uploadError: null
    },
    getters: {
        GET_RENDER_SCHEDULER(state) {
            return state.renderScheduler
        },
        GET_LOADING(state) {
            return state.loading;
        },
        GET_UPDATE_LOADING(state) {
            return state.updateLoading;
        },
        GET_SCHEDULER_EVENTS(state) {
            return state.schedulerEvents;
        },
        GET_UPLOAD_SUCCESS(state) {
            return state.uploadedData
        },
        GET_UPLOAD_FAILURE(state) {
            return state.uploadError
        },
        GET_TOTAL(state) {
            return state.total;
        }
    },
    mutations: {
        SET_RENDER_SCHEDULER(state, value) {
            state.renderScheduler = value;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_UPDATE_LOADING(state, loading) {
            state.updateLoading = loading;
        },
        SET_SCHEDULER_EVENTS(state, value) {
            state.schedulerEvents = value
        },
        SET_UPLOAD_SUCCESS(state, data) {
            state.uploadedData = data;
        },
        SET_UPLOAD_FAILURE(state, error) {
            state.uploadError = error;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        }
    },
    actions: {
        GET({ commit, state }, payload) {
            commit('SET_LOADING', true);
            return new Promise((resolve, reject) => {
                let params = { ...state.options };
                params.sortBy = params.sortBy?.length ? params.sortBy[0] : null;
                params.typeId = payload.typeId ?? router.currentRoute?.params?.taskTypeId
                schedulerService
                    .get(params)
                    .then((response) => {
                        var events = response.data.items.map(mapEvent);
                        commit('SET_SCHEDULER_EVENTS', events);
                        commit('SET_TOTAL', response.data.total);
                        resolve(state.schedulerEvents);
                    })
                    .catch((error) => {
                        debugError(error);
                        commit('SET_LOADING', false);
                        reject(error);
                    })
                    .finally(() => {
                        commit('SET_LOADING', false);
                    });
            })
        },
        GET_BY_ID(context, id) {
            return schedulerService.getById(id).catch((err) => {
                $handleError(err);
            });
        },
        UPDATE({ commit, dispatch }, payload) {
            commit('SET_UPDATE_LOADING', true);
            return new Promise((resolve, reject) => {
                schedulerService
                    .update(payload)
                    .then(() => {
                        commit('SET_UPDATE_LOADING', false);
                        dispatch('GET', payload.taskTypeId);
                        resolve();
                    })
                    .catch((error) => {
                        debugError(error);
                        reject(error);
                    });
            });
        },
        DELETE({ dispatch }, payload) {
            schedulerService
                .delete(payload.id)
                .then(() => {
                    dispatch('GET', payload.taskTypeId);
                })
                .catch((err) => {
                    debugError('SCHEDULER', 'DELETE error', err);
                });
        },
        UPLOAD_DOCUMENT({ commit }, file) {
            schedulerService.uploadDocument(file).then((res) => {
                commit('UPLOAD_SUCCESS', res.data);
            })
                .catch((err) => {
                    debugError('SCHEDULER', 'UPLOAD_DOCUMENT error', err);
                    commit('UPLOAD_FAILURE', err);
                });
        }
    }
}

function mapEvent(ev) {
    if (!ev) return null;

    ev.start_date = moment(ev.start_date).format('YYYY-MM-DD HH:mm:ss');

    ev.endDate = moment(ev.endDate).format('YYYY-MM-DD HH:mm:ss');

    ev.end_date = moment(ev.end_date ?? ev.endDate).format('YYYY-MM-DD HH:mm:ss');
    
    return ev;
}